import '/app/brewery-packages/content/content-editor-plugin-quote/src/Quote.css-raw';
export default {
  "quote": "about-us-b998e096-quote-D9SRnq",
  "icon": "about-us-b998e096-icon-D9SRnq"
};